import { all } from "redux-saga/effects";
import getGiftExchangePoint from "./getGiftExchangePoint";
import postCreateOrderExchangePoint from "./postCreateOrderExchangePoint";

export const giftExchangePageSaga = function* root() {
	yield all([getGiftExchangePoint(), postCreateOrderExchangePoint()]);
};
